import '../styles/Primitives.scss';
import { mergeSx } from '../_internal/styleProps';

export default function Avatar({ alt = '', children, className = '', src, style, sx, ...props }) {
  return <span className={`ui-avatar ${className}`.trim()} style={mergeSx(sx, style)} {...props}>{src ? <img src={src} alt={alt} /> : children}</span>;
}
